import React from 'react';
// import Facebook from './facebook/Facebook'
import Maincntr from './facebookapp/Maincntr';

function App() {
  return <Maincntr />
  // return <Facebook />
}

export default App;